/** API route map: URLS.Controller.Twilio */
export const Twilio = {
      Name: 'TwilioSMS/',
      GetAllSms: 'get-all-sms',
      SendSms: 'send-sms',
      AddConfiguration: 'add-configuration',
      UpdateConfiguration: 'update-configuration',
      GetConfiguration: 'get-configuration',
      GetNumbers: 'get-numbers',
      GetCallers: 'get-caller-ids',
      ToggleActivation: 'toggle-activation',
      Disconnect: 'disconnect',
      GetEmployeeMessages: 'get-employee-messages',
};
